import { render } from "./i18n-toggle.vue?vue&type=template&id=0677f3cb&scoped=true"
import script from "./i18n-toggle.vue?vue&type=script&lang=js"
export * from "./i18n-toggle.vue?vue&type=script&lang=js"

import "./i18n-toggle.vue?vue&type=style&index=0&id=0677f3cb&lang=scss&scoped=true"

import exportComponent from "/Users/girgisnabil/Documents/projects/home-food-plus-full-stack/source/admin/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0677f3cb"]])

export default __exports__